import * as array from 'd3-array'

/*
 * Determines the threshold arc to use based on the incoming value
 * This might not match the actual data from SB3, it should only be used
 * as a pointer is rotating.
 */
export default function (colors, value, thresholds) {
  return () => {
    let _thresholds = thresholds.slice().sort(array.ascending) // Create a copy of the sorted thresholds
      , idx = array.bisectRight(_thresholds, value) // Find the insertion order in the sorted values
      , idxOffset = 0

    if (_thresholds[0] !== thresholds[0]) {
      // The incoming thresholds are in descending order, so we need to flip the index
      idx = thresholds.length - idx
    }

    if (idx >= thresholds.length) {
      // Value is too good, make sure arc is between the last threshold
      idx--
    }

    if (idx === 0) {
      // Value is too bad, make sure arc is drawn at the first threshold
      idx = 1
    }

    return {
      start: thresholds[idx - 1],
      end: thresholds[idx + idxOffset],
      color: colors[idx - 1]
    }
  }
}
